import {
  CAMP_LIST,
  CREATE_MEETING,
  POC_LIST_DROPDOWN,
  MEETING_BY_ID,
  CANCEL_MEETING,
  COMPLETE_MEETING,
  VIEW_MOM,
  VENDOR_LIST,
  GET_PRECAMP_QUES,
  POST_PRECAMP_QUES,
  ADD_POST_CAMP,
  VIEW_VENDOR,
  CAMP_APPROVAL,
  INFRA_ID,
  CARNIVAL_LIST,
  CARNIVAL_DETAIL,
  CARNIVAL_DATA,
  NORMAL_BOARDING_LISTING,
  NORMAL_ONBAORDING_DATA,
  PROJECT_ONBOARDING_LISTING,
  HELPDESK_LIST,
  HELPDESK_DETAIL,
  HELPDESK_DATA,
  CLIENT_ADDRESS_DETAILS,
  BUSINESS_ADDRESS_DETAILS
} from "./type";

const initialState = {
  campList: [],
  meetingData: {},
  pocList: [],
  meetingById: {},
  cancel: [],
  complete: [],
  vendorList: [],
  momBymeetingId: null,
  questionnaireList: null,
  questionnaireSaveRes: null,
  postCampRes: null,
  vendorDetails: [],
  campApproval: [],
  carnivalList: [],
  carnivalDetail: [], 
  carnivalData: null,
  leadInfraId: [],
  normalOnboardingListing: [],
  normalOnboradingData :null,
  projectOnboradingListing : [],
  helpdeskList: [],
  helpdeskDetail: [],
  helpdeskData: [],
  clientAddressDetails : []
};

const ConductCampReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CAMP_LIST:
      return {
        ...state,
        campList: payload,
      };
    case CREATE_MEETING:
      return {
        ...state,
        meetingData: payload,
      };
    case POC_LIST_DROPDOWN:
      return {
        ...state,
        pocList: payload,
      };
    case MEETING_BY_ID:
      return {
        ...state,
        meetingById: payload,
      };
    case CANCEL_MEETING:
      return {
        ...state,
        cancel: payload,
      };
    case COMPLETE_MEETING:
      return {
        ...state,
        complete: payload,
      };
    case VIEW_MOM:
      return {
        ...state,
        momBymeetingId: payload,
      };
    case VENDOR_LIST:
      return {
        ...state,
        vendorList: payload,
      };
    case GET_PRECAMP_QUES:
      return {
        ...state,
        questionnaireList: payload,
      };
    case POST_PRECAMP_QUES:
      return {
        ...state,
        questionnaireSaveRes: payload,
      };
    case ADD_POST_CAMP:
      return {
        ...state,
        postCampRes: payload,
      };
    case VIEW_VENDOR:
      return {
        ...state,
        vendorDetails: payload,
      }
    case CAMP_APPROVAL:
      return {
        ...state,
        campApprove: payload,
      }
    case INFRA_ID:
      return {
        ...state,
        leadInfraId: payload,
      }
    case CARNIVAL_LIST:
      return {
        ...state,
        carnivalList: payload,
      }
    case CARNIVAL_DETAIL:
      return {
        ...state,
        carnivalDetail: payload,
      }
    case CARNIVAL_DATA:
      return {
        ...state,
        carnivalData: payload,
      }
    case NORMAL_BOARDING_LISTING:
      return {
        ...state,
        normalOnboardingListing: payload,
      }
    case NORMAL_ONBAORDING_DATA:
      return {
        ...state,
        normalOnboradingData: payload,
      }
    case PROJECT_ONBOARDING_LISTING:
      return {
        ...state,
        projectOnboradingListing: payload,
      }
    case HELPDESK_LIST:
      return {
        ...state,
        helpdeskList: payload,
      }
    case HELPDESK_DETAIL:
      return {
        ...state,
        helpdeskDetail: payload,
      }
    case HELPDESK_DATA:
      return {
        ...state,
        helpdeskData: payload,
      }
    case CLIENT_ADDRESS_DETAILS:
      return {
        ...state,
        clientAddressDetails: payload,
      } 
    case BUSINESS_ADDRESS_DETAILS:
      return {
        ...state,
        businessAddressDetails: payload,
      }    
    default:
      return {
        ...state,
      };
  }
};

export default ConductCampReducer;
